class WebUtils {
  // create cookie
  static setCookie(name, value, days, akt) {
    let expires;
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toGMTString()}`;
    } else {
      expires = '';
    }
    document.cookie = `${name}=${value}${expires}; path=/`;
    if (akt !== null && akt === 'r') {
      setTimeout(() => window.location.reload(false), 200);
    }
  }

  // get cookie
  static getCookie(c_name) {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(`${c_name}=`);
      if (c_start !== -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(';', c_start);
        if (c_end === -1) {
          c_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return '';
  }

  // erase cookie
  static rmvCookie(name) {
    if (!WebUtils.getCookie(name)) return;
    WebUtils.setCookie(name, '', -1);
  }

  static getLang() {
    let lang = WebUtils.getCookie('lang') || localStorage.getItem('lang');
    if (lang === null || lang === undefined || lang === '') lang = 'en';
    return lang;
  }

  static poiGetDef(poi, field) {
    const lang = WebUtils.getLang();
    return WebUtils.poiGet(poi, field, lang);
  }

  static poiGet(poi, field, lang) {
    if (!poi || !poi.details) return null;
    let details = poi.details[`${lang}`];
    if (!details) {
      for (const l in poi.details) {
        details = poi.details[l];
        break;
      }
    }
    if (!details || !details[`${field}`]) return null;
    return details[`${field}`];
  }

  static getSnodeField(snode, name) {
    const lang = WebUtils.getLang();
    if (!snode[name]) return null;
    return snode[name][lang];
  }
}

export default WebUtils;
